/* PDP pass 5: variant sync, AJAX Add to Cart, BUY NOW -> /checkout, live flash timer.
   Uses delegated listeners so it works with the sticky bar that the section
   script re-mounts on <body>. */
(function () {
  'use strict';

  var data = null;
  var busy = false;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }

  function readData() {
    var el = qs('[data-pdp-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- helpers ---------- */
  function toast(msg, isError) {
    var t = qs('#AppPdpToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'AppPdpToast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.className = 'app-pdp-toast is-visible' + (isError ? ' is-error' : '');
    clearTimeout(t._tm);
    t._tm = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  function variantId() {
    var input = qs('#AppPdpVariantInput');
    return input ? input.value : '';
  }

  function quantity() {
    var q = qs('#AppPdpQtyInput');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }

  function variantById(id) {
    if (!data) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(id)) return data.variants[i];
    }
    return null;
  }

  /* ---------- cart ---------- */
  function addToCart() {
    var id = variantId();
    if (!id) return Promise.reject(new Error('Please select an option'));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity() }] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) {
          throw new Error(body.description || body.message || 'Could not add to cart');
        }
        return body;
      });
    });
  }

  function setCount(n) {
    qsa('.cart-count-bubble, .va-header__bag-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
    var cartLink = qs('.app-pdp__cart');
    var badge = qs('.app-pdp__cart-badge');
    if (cartLink && !badge && n > 0) {
      badge = document.createElement('span');
      badge.className = 'app-pdp__cart-badge';
      cartLink.appendChild(badge);
    }
    if (badge) {
      badge.textContent = n;
      badge.style.display = n > 0 ? '' : 'none';
      if (badge.animate) {
        badge.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 300 });
      }
    }
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        window.dispatchEvent(new CustomEvent('vesture:cart:changed'));
        return cart;
      });
  }

  function labelOf(btn) {
    if (btn && btn.dataset.label === undefined) btn.dataset.label = btn.textContent;
    return btn ? btn.dataset.label : '';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!data || !form || form.id !== data.formId) return;
    e.preventDefault();
    if (busy) return;
    var btn = qs('.app-pdp__sticky-add-cart');
    if (btn && btn.disabled) return;
    busy = true;
    var original = labelOf(btn);
    if (btn) { btn.classList.add('is-loading'); btn.textContent = 'Adding...'; }
    addToCart()
      .then(refreshCount)
      .then(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = 'Added \u2713';
        }
        toast('Added to your bag');
        setTimeout(function () {
          if (btn) { btn.classList.remove('is-added'); btn.textContent = original; }
        }, 1800);
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.textContent = original; }
        toast(err.message || 'Could not add to cart', true);
      })
      .then(function () { busy = false; });
  });

  document.addEventListener('click', function (e) {
    var buy = e.target.closest ? e.target.closest('[data-buy-now]') : null;
    if (!buy || buy.disabled) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    buy.classList.add('is-loading');
    buy.setAttribute('aria-busy', 'true');
    addToCart()
      .then(function () { window.location.assign('/checkout'); })
      .catch(function (err) {
        buy.classList.remove('is-loading');
        buy.removeAttribute('aria-busy');
        busy = false;
        toast(err.message || 'Could not start checkout', true);
      });
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    busy = false;
    qsa('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); el.removeAttribute('aria-busy'); });
  });

  /* ---------- variant selection (size pills) ---------- */
  function matchVariant(opts) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var n = 0; n < 3; n++) {
        if (opts[n] != null && v['option' + (n + 1)] !== opts[n]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function firstWithOption(idx, value) {
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i]['option' + (idx + 1)] === value) return data.variants[i];
    }
    return null;
  }

  function applyVariant(v) {
    var input = qs('#AppPdpVariantInput');
    var hidden = qs('#AppPdpSelectedVariantId');
    if (input) input.value = v.id;
    if (hidden) hidden.value = v.id;

    qsa('.app-pdp__size-pill').forEach(function (p) {
      var i = data.optionNames.indexOf(p.getAttribute('data-option-name'));
      p.classList.toggle('is-selected', v['option' + (i + 1)] === p.getAttribute('data-option-value'));
    });

    var price = data.prices[String(v.id)];
    var priceEl = qs('#AppPdpPrice');
    if (price && priceEl) priceEl.textContent = price;
    var buyMain = qs('.app-pdp__sticky-buy-main');
    if (price && buyMain) buyMain.textContent = 'BUY NOW \u2014 ' + price;

    var add = qs('.app-pdp__sticky-add-cart');
    var buy = qs('.app-pdp__sticky-buy-now');
    if (add) {
      var base = labelOf(add);
      if (base === 'Sold Out') { add.dataset.label = 'Add to Cart'; base = 'Add to Cart'; }
      add.disabled = !v.available;
      add.textContent = v.available ? base : 'Sold Out';
    }
    if (buy) buy.disabled = !v.available;

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (err) { /* non-critical */ }
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest ? e.target.closest('.app-pdp__size-pill') : null;
    if (!pill || !data) return;
    var name = pill.getAttribute('data-option-name');
    var value = pill.getAttribute('data-option-value');
    var idx = data.optionNames.indexOf(name);
    if (idx < 0) return;
    var cur = variantById(variantId());
    var opts = cur ? [cur.option1, cur.option2, cur.option3] : [null, null, null];
    opts[idx] = value;
    var match = matchVariant(opts) || firstWithOption(idx, value);
    if (match) applyVariant(match);
  });

  /* ---------- flash sale timer ---------- */
  function initFlash() {
    var box = qs('#AppPdpFlash');
    if (!box) return;
    var hrsEl = qs('#fs-hours');
    var minEl = qs('#fs-mins');
    var secEl = qs('#fs-secs');
    var csEl = qs('#fs-cs');
    if (!hrsEl || !minEl || !secEl || !csEl) return;

    var hours = parseInt(box.getAttribute('data-flash-hours'), 10) || 24;
    hours = Math.max(1, Math.min(72, hours));
    var duration = hours * 3600000;
    var KEY = 'va_flash_sale_v1';
    var end = 0;

    try {
      var saved = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      if (saved && saved.hours === hours && saved.end > Date.now() && saved.end - Date.now() <= duration) {
        end = saved.end;
      }
    } catch (err) { /* storage unavailable: fall back to in-memory */ }

    function restart() {
      end = Date.now() + duration;
      try { window.localStorage.setItem(KEY, JSON.stringify({ end: end, hours: hours })); } catch (err) { /* ignore */ }
    }
    if (!end) restart();

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    var last = {};
    function put(el, key, text) {
      if (last[key] !== text) { last[key] = text; el.textContent = text; }
    }

    function frame() {
      var left = end - Date.now();
      if (left <= 0) { restart(); left = end - Date.now(); }
      put(hrsEl, 'h', pad(Math.floor(left / 3600000)));
      put(minEl, 'm', pad(Math.floor((left % 3600000) / 60000)));
      put(secEl, 's', pad(Math.floor((left % 60000) / 1000)));
      put(csEl, 'c', pad(Math.floor((left % 1000) / 10)));
      window.requestAnimationFrame(frame);
    }
    frame();
  }

  function init() {
    data = readData();
    initFlash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();